import { ref, computed, watch, onUnmounted } from 'vue'
import StarterKit from '@tiptap/starter-kit'

export function useEditor(initialContent = '', options = {}) {
  const {
    autoSave = false,
    autoSaveDelay = 1000,
    enableHistory = true
  } = options

  const content = ref(initialContent)
  const isEditing = ref(false)
  const isSaving = ref(false)
  const lastSaved = ref(null)
  
  // Debounce simples
  let saveTimeout = null
  
  const debounce = (fn, delay) => {
    return (...args) => {
      if (saveTimeout) clearTimeout(saveTimeout)
      saveTimeout = setTimeout(() => fn(...args), delay)
    }
  }
  
  const saveContent = async () => {
    isSaving.value = true
    try {
      await new Promise(resolve => setTimeout(resolve, 300))
      lastSaved.value = new Date()
      console.log('Conteúdo salvo:', content.value)
    } finally {
      isSaving.value = false
    }
  }
  
  const debouncedSave = debounce(saveContent, autoSaveDelay)
  
  watch(content, () => {
    if (autoSave) {
      debouncedSave()
    }
  })
  
  onUnmounted(() => {
    if (saveTimeout) clearTimeout(saveTimeout)
  })
  
  return {
    content,
    isEditing,
    isSaving,
    lastSaved,
    saveContent,
    characterCount: computed(() => content.value.length),
    wordCount: computed(() => {
      return content.value.trim() === '' 
        ? 0 
        : content.value.trim().split(/\s+/).length
    })
  }
}